import { ActionButton } from 'src/app/components/dtos/Common.dto';
import { AuditColumnDTO, AuditLogResponseDTO } from 'src/app/components/audit-log-v2/audit-log-v2.constant';
import { AuditEntityCode } from '../audit.codes';

export interface ChangeHistoryOptions {
  entities: readonly AuditEntityCode[];
  identifierId: string | number;
  identifierName: string;
  excludedActions?: readonly string[];
}

export interface ChangeHistoryRequest {
  entityIds: readonly string[];
  identifierId: string | number;
  excludedActions?: readonly string[];
}

export const CHANGE_HISTORY_SESSION_ACTIONS: readonly string[] = ['LOGIN', 'LOGIN_FAILED', 'LOGOUT', 'AUTHENTICATION'];

export interface ChangeHistoryResponse {
  total: number;
  capped: boolean;
  entries: AuditLogResponseDTO[];
}

export type ChangeHistoryRow = Record<string, string>;

export interface ChangeHistoryEntry {
  id: string;
  action: string;   // shown as stored, as on the audit log screen
  userName: string;
  initials: string;
  dayKey: string;     // yyyy-MM-dd in the user's timezone, for the date filters
  dateText: string;   // Oct 6, 2026
  timeText: string;   // 11:06:26 AM
  rows: ChangeHistoryRow[];
}

export interface ChangeHistoryVisibleEntry extends ChangeHistoryEntry {
  visibleRows: ChangeHistoryRow[];
  sharedReason: string | null;
}

export type ChangeHistoryColumn = AuditColumnDTO;

export const CHANGE_HISTORY_REASON_KEY = 'reason';

export const CHANGE_HISTORY_TEXT = {
  title: 'Change History',
  searchPlaceholder: 'Search fields, values, reasons, dates or users',
  fromDate: 'From date',
  toDate: 'To date',
  all: 'All',
  loading: 'Loading changes…',
  empty: 'No changes recorded yet.',
  noMatch: 'No changes match these filters.',
  clearFilters: 'Clear filters',
  noFieldChanges: 'No field changes recorded',
  change: 'change',
  changes: 'changes',
  expandAll: 'Expand all',
  collapseAll: 'Collapse all',
  close: 'Close',
  loadFailed: 'Could not load the change history.'
} as const;

export const CHANGE_HISTORY_EMPTY_VALUE = '—';

/** "Oct 6, 2026" / "11:06:26 AM" / "2026-10-06" in the user's timezone. */
export const CHANGE_HISTORY_DATE_FORMAT = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
export const CHANGE_HISTORY_TIME_FORMAT = new Intl.DateTimeFormat('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true });
export const CHANGE_HISTORY_DAY_KEY_FORMAT = new Intl.DateTimeFormat('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' });

export const CHANGE_HISTORY_ACTION = 'history';

export const CHANGE_HISTORY_ACTION_BUTTON: ActionButton = {
  show: true, title: CHANGE_HISTORY_TEXT.title, iconClass: 'historyIcon', testId: 'btn-history', action: CHANGE_HISTORY_ACTION
};
